<script>
export default {
  methods: {
    async defaultBillingYm () {
      var defaultYM = ''
      // var ym

      // デフォルト請求年月をセッションから取得
      defaultYM = await this.getBillingYmFromSession()
      // セッションから取得不可⇒DBから取得
      if (defaultYM === '') {
        defaultYM = await this.getBillingYmFromRDS()
      }
      // ym = new Date(defaultYM.substr(0, 4) + '/' + defaultYM.substr(4, 2) + '/1')
      // return String(ym.getFullYear()) + String(ym.getMonth() + 1).padStart(2, '0')
      return defaultYM
    },
    async getBillingYmFromSession () {
      var defaultYM = this.getDefaultBillingYm()
      return defaultYM
    },
    async getBillingYmFromRDS () {
      // デフォルト請求年月
      var defaultYM = ''

      await this.$axios
        .get('/invoice-operation', { params: {} })
        .then((res) => {
          // 当月確定月存在
          if (res.data.list.length > 0) {
            // 最新当月確定年月（='YYYYMM'）
            var latestYM = res.data.list[0].latest_billing_ym
            // 最新当月確定年月（=yyyy/MM/01）
            var latestBiilingDate = new Date(latestYM.substr(0, 4) + '/' + latestYM.substr(4, 2) + '/1')
            // デフォルト請求年月（=yyyy/MM/01:最新当月確定年月+1ヵ月）
            latestBiilingDate.setMonth(latestBiilingDate.getMonth() + 1)
            // デフォルト請求年月（='YYYYMM':getMonthは1ヵ月ずれるため+1で取得）
            defaultYM = latestBiilingDate.getFullYear() + String(latestBiilingDate.getMonth() + 1).padStart(2, '0')
          } else {
          // 当月確定月未存在
            var today = new Date()
            // デフォルト請求年月（=yyyy/MM/01:操作年月）
            today.setMonth(today.getMonth())
            // デフォルト請求年月（='YYYYMM':getMonthは1ヵ月ずれるため+1で取得）
            defaultYM = today.getFullYear() + String(today.getMonth() + 1).padStart(2, '0')
          }
        })
        .catch((e) => {
          console.log(e)
          var today = new Date()
          // デフォルト請求年月（=yyyy/MM/01:操作年月）
          today.setMonth(today.getMonth())
          // デフォルト請求年月（='YYYYMM':getMonthは1ヵ月ずれるため+1で取得）
          defaultYM = today.getFullYear() + String(today.getMonth() + 1).padStart(2, '0')
        })
      return defaultYM
    },
    getDefaultBillingYm () {
      var defaultYM = ''
      if (this.$session.get('latestBillingYM') !== undefined) {
        if (this.$session.get('latestBillingYM') !== '') {
          defaultYM = this.$session.get('latestBillingYM')
        }
      }
      return defaultYM
    }
  }
}
</script>
